export const FEATURE_TYPES_INDEX_TOUR = {
  id: "feature_types_index",
  steps: [
    {
      element: '[data-tour="feature-types-create"]',
      popover: {
        title: "Nova feature",
        description:
          "Features são flags booleanas que você liga por plano e envia nos webhooks para o seu sistema.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="feature-types-list"]',
      popover: {
        title: "Features cadastradas",
        description: "Chave, label e descrição de cada feature disponível.",
        side: "top",
      },
    },
  ],
};
